package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.LogoutRequest
import com.arena_web.domain.repositories.AuthRepository
import com.arena_web.utils.Storage
import com.arena_web.utils.StorageKeys

class LogoutUseCase(private val authRepository: AuthRepository) {

    suspend operator fun invoke(): Result<Unit> {
        val refreshToken = Storage.get(StorageKeys.REFRESH_TOKEN)
        val result = if (refreshToken != null) {
            authRepository.logout(LogoutRequest(refreshToken))
        } else {
            Result.success(Unit)
        }
        // Always clear local session, even if API call fails
        Storage.clearSession()
        return result
    }
}
